import React from 'react';
import i18n from "../i18n";

export const LoadingView = () => {
    return (
        <div className="d-flex justify-content-center" style={{"height": "100%"}}>
            <div className="spinner-container">
                <div className="spinner" style={{
                    width: '60px',
                    height: '60px',
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #3498db',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}></div>
                <div style={{marginTop: '10px', textAlign: 'center'}}>
                    {`${i18n.t('universal:loading')}...`}
                </div>
            </div>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    )
}
